import { Box, Text } from '@chakra-ui/react';

import { addMonths } from 'date-fns/addMonths';
import { startOfMonth } from 'date-fns/startOfMonth';

import { dateHelpers } from '@nocowanie/core/helpers';
import { IconsLinear } from '@nocowanie/icons/linear';

import { defaultRangePickerConfig, RangePickerConfig } from './range-picker.config';
import { RangePickerHeaderProps } from './range-picker-header.props';

export const RangePickerHeader = ({
    monthDate,
    customHeaderCount,
    decreaseMonth,
    increaseMonth,
    isMobile,
}: RangePickerHeaderProps) => {
    const {
        translationData: { ariaLabel },
    }: Required<RangePickerConfig> = { ...defaultRangePickerConfig };
    const currentMonth = new Date();
    const minMonth = startOfMonth(addMonths(currentMonth, 1));
    const maxMonth = startOfMonth(addMonths(currentMonth, 10));

    const isPrevDisabled = monthDate < minMonth;
    const isNextDisabled = monthDate >= maxMonth;
    const monthName = dateHelpers.format(monthDate, 'LLLL yyyy');

    const prevBtnDisplay = customHeaderCount === 1 || isPrevDisabled ? 'none' : 'flex';
    const nextBtnDisplay = customHeaderCount === 0 || isNextDisabled ? 'none' : 'flex';

    return (
        <Box
            className="react-datepicker__header"
            p={isMobile ? 0 : '8px 0'}
            textAlign={isMobile ? 'left' : 'center'}
        >
            {!isMobile ? (
                <button
                    type="button"
                    className="react-datepicker__navigation react-datepicker__navigation--previous"
                    style={{
                        display: prevBtnDisplay,
                        top: '4px',
                    }}
                    onClick={() => {
                        requestAnimationFrame(() => {
                            decreaseMonth();
                        });
                    }}
                    aria-label={ariaLabel.prevMonth}
                >
                    <IconsLinear.ArrowLeft2 size={'sm'} />
                </button>
            ) : null}
            <Text as={'span'} className="react-datepicker__current-month">
                {monthName}
            </Text>
            {!isMobile ? (
                <button
                    type="button"
                    className="react-datepicker__navigation react-datepicker__navigation--next"
                    style={{
                        display: nextBtnDisplay,
                        top: '2px',
                    }}
                    onClick={() => {
                        requestAnimationFrame(() => {
                            increaseMonth();
                        });
                    }}
                    aria-label={ariaLabel.nextMonth}
                >
                    <IconsLinear.ArrowRight2 size={'sm'} />
                </button>
            ) : null}
        </Box>
    );
};
